import React from "react";
import SalesPageEditContainer from "../../modules/GASalesPages/containers/SalesPageEditContainer/SalesPageEditContainer";

const GASalesPageEdit = () => {
  return <SalesPageEditContainer />;
};

export default GASalesPageEdit;
